import { useMutation, useQuery, useQueryClient } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useBudgetThresholds = (projectId, config) =>
  useQuery({
    ...config,
    queryKey: [`budget-thresholds`, projectId],
    queryFn: () =>
      fetch({
        url: `${Angie.api_url}/projects/${projectId}/budget-thresholds`,
      }),
  });
export const useUpdateBudgetThresholds = (projectId) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (attributes) => {
      return fetch({
        url: `${Angie.api_url}/projects/${projectId}/budget-thresholds`,
        method: "post",
        body: { project_id: projectId, attributes },
      });
    },
    onSuccess: (res) => {
      queryClient.invalidateQueries([`budget-thresholds`, projectId]);
      return res;
    },
  });
};
